module.exports = __webpack_public_path__ + "static/img/mobilebg.678e0bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/TiiVii/mobilebg.png
// module id = /vsQ
// module chunks = 0